import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { UnderlinedHeader } from '@components/typographies';

import * as styles from './Header.module.scss';

export const Header: React.FC = () => {
	return (
		<PaddingContainer className={classNames(styles.header, 'white-bg')}>
			<WidthContainer>
				<UnderlinedHeader
					className="limit-text"
					dividerStyles={{ maxWidth: 350 }}
					subtitle="Over 13 years, EMBIQ fulfilled the most unusual and complex projects for partners worldwide. Find examples of the finest work delivered by EMBIQ specialists."
				>
					Case studies
				</UnderlinedHeader>
			</WidthContainer>
		</PaddingContainer>
	);
};
